import { EventsDTO } from "../domain/models/dto/EventsDTO";
import { IEvents } from "../domain/models/Events";
import { EventsModel } from "../models/EventsModel";
import { FileMapper } from "./FileMapper";
import { EventsTranslationMapper } from "./EventTranslationMapper";
import { SimpleMapper } from "./SimpleMapper";

export class EventsMapper extends SimpleMapper<IEvents, EventsDTO> {
    protected toDTOFields: string[] = [
        "id",
        "files",
        "translations",
        "eventDate",
        "location",
        "format",
    ];
    protected fromDTOFields: string[] = [
        ...this.toDTOFields,
        "availableLangs",
        "creatorId",
        "createdAt",
        "updatedAt",
    ];
    protected entityConstructor = EventsModel;
    private fileMapper = new FileMapper();
    private eventsTranslationMapper = new EventsTranslationMapper();

    toDTO(model: IEvents): EventsDTO {
        if (!model) {
            return null;
        }

        const baseDto = super.toDTO(model);

        baseDto.translations =
            model.translations?.map((t) =>
                this.eventsTranslationMapper.toDTO(t)
            ) ?? [];

        baseDto.files =
            model.files?.map((file) => this.fileMapper.toDTO(file)) ?? [];

        return baseDto;
    }

    fromDTO(dto: EventsDTO): IEvents {
        if (!dto) {
            return null;
        }
        const baseModel = super.fromDTO(dto);

        baseModel.translations =
            dto.translations?.map((t) =>
                this.eventsTranslationMapper.fromDTO(t)
            ) ?? [];

        baseModel.files =
            dto.files?.map((file) => this.fileMapper.fromDTO(file)) ?? [];
        return baseModel;
    }
}
